import ReviewPromptModal from './components/ReviewPromptModal.vue';

export default {
    install(app) {
        app.component('ReviewPromptModal', ReviewPromptModal);
    }
};